import script from "./testDataList.vue?vue&type=script&lang=js"
export * from "./testDataList.vue?vue&type=script&lang=js"

import "./testDataList.vue?vue&type=style&index=0&id=0db066e2&lang=css"

const __exports__ = script;

export default __exports__